if($('.html-video-slide-swipe').length){
  hp.swipers = hp.swipers || {};
  hp.htmlVideoRay = {};
  var html_video_slide_swipe = 
  {
    initialized: false
  };

  html_video_slide_swipe.init = function(){

    var videoSlideProps = {
      
      navigation: {
        nextEl: '.right-arrow-video4',
        prevEl: '.left-arrow-video4',
      },
      lazy: false,
      slidesPerView: 1.5,
      spaceBetween: 20,
      // loop: true,
      breakpoints: {
        1200: {
          slidesPerView: 1.3,
          spaceBetween: 20
        },
        1000: {
          slidesPerView: 1.25,
          spaceBetween: 20
        },
        1024: {
          slidesPerView: 1.2,
          spaceBetween: 20
        },
        800: {
          slidesPerView: 1,
          spaceBetween: 20
        },
        767: {
          slidesPerView: 1,
          spaceBetween: 16
        }
      }
    }
    var videoSlideMethods = {
      resizeHandler: true,
      a11ySwiper: true,
     
    }

    

    html_video_slide_swipe.instances = hp.swiperInstance('.html-video-slide-swipe', videoSlideProps, videoSlideMethods, propsModifier);
    // console.log('htmlVideoSlides', htmlVideoSlide)
    
    
    // youtube iframe gets focus we move to that slide
    window.addEventListener('blur',function(){
      if(document.activeElement.className === 'html-video-player'){
        var $par = $(document.activeElement.parentNode.parentNode);
        if(html_video_slide_swipe.instances.length > 1){
          html_video_slide_swipe.instances[$(document.activeElement).parents('.html-video-slide-swipe').data('id')].slideTo($par.index());        
        }else{
          html_video_slide_swipe.instances.slideTo($par.index());          
        }
      } 
    });
    
    // placeholder play button gets focus we move to that slide
    $(".html-video-slide-swipe .swiper-slide>div>a").on('focus', function(){
      // console.log('Focus');
      hp.stopOtherVids();
      var $par = $(this).parent().parent()
      $par.addClass('color_ff')// show white focus outline
      html_video_slide_swipe.instances[parseInt($(this).parents('.html-video-slide-swipe').data('id'))].slideTo($par.index())
    });

    // placeholder play button gets click or keyup we load youtube video
    $(".html-video-slide-swipe .swiper-slide>div>a").on('click keyup', function(event){
      event.preventDefault();
      event.stopPropagation();
      if([1,13].indexOf(event.which)<0){
        return false;
      }
      var $thisContainer = $(this).parents('.card-module-container'),
          left = $(this).offset().left,
          compare = $thisContainer.offset().left + $thisContainer.width()-50;
          
      if(left > compare){return}
      
      var videoId = $(this).next().attr('data-video-id'),
          iframeId,
          videoUrl;
      $('.video-iframe[data-video-id='+videoId+']').each(function(i,x){
        iframeId = videoId+'_'+i;
        videoUrl = $(x).data('video-url');
        $(x).attr('id',iframeId).show().prev().css('display','none').parent().addClass('fade-to-black').prepend('<h3 style="opacity:0;height:0;width:0;margin:0;">'+ $(x).prev().html().replace('play','') +'</h3>');
        initializeHtmlPlayer(videoId,iframeId,videoUrl, x);
      })
    });
    
    // stop other vids and update pagination if slide changes
    if(html_video_slide_swipe.instances.length > 1){
      for(var i = 0; i < html_video_slide_swipe.instances.length; i++){
        $('.new-pagination-type-variation', $(html_video_slide_swipe.instances[i].$el)).addClass('new-pagination-type-variation-'+$(html_video_slide_swipe.instances[i].$el).data('id'))
        html_video_slide_swipe.instances[i].on('slideChangeTransitionStart', function () {
          hp.stopOtherVids()
          // last slide does not slide all the way left so this is minor hack to fix issue with pagination
          showHideArrows(this)
          var arrowLeftVis = this.activeIndex == 0 ? 'hidden' : 'visible',
              arrowRightVis = this.activeIndex == this.slides.length-1 ? 'hidden' : 'visible';
          $('.new-pagination-type-variation-'+$(this.$el).data('id')).html(this.activeIndex+1)
          $(this.navigation.$prevEl).css('visibility',arrowLeftVis)
          $(this.navigation.$nextEl).css('visibility',arrowRightVis)
        });
      } 
    }else{
      html_video_slide_swipe.instances.on('slideChangeTransitionStart', function () {
        hp.stopOtherVids()
        // last slide does not slide all the way left so this is minor hack to fix issue with pagination
        showHideArrows(this)
        var arrowLeftVis = this.activeIndex == 0 ? 'hidden' : 'visible',
            arrowRightVis = this.activeIndex == this.slides.length-1 ? 'hidden' : 'visible';
        $('.new-pagination-type-variation').html(this.activeIndex+1)
        $(this.navigation.$prevEl).css('visibility',arrowLeftVis)
        $(this.navigation.$nextEl).css('visibility',arrowRightVis)
      });
    }
  }//END init

  function propsModifier(swiper, props){
    if($(window).width() > 767){
      var offsetAfter = $(".swiper-wrapper .swiper-slide", swiper).width() / 2;
      var modifiedProps = JSON.parse(JSON.stringify(props));
      modifiedProps.slidesOffsetAfter = offsetAfter;
      return modifiedProps;
    }else{
      return props;
    }
  }
  function onPlayerReady(event){
    //console.log('onPlayerReady',event.target)
    //event.target.postMessage('{"event":"command","func":"stopVideo","args":""}', '*');
  }
  function onPlayerStateChange(event){
    //console.log('onPlayerStateChange',event.target.a.id)
    event.data === 1 && hp.stopOtherVids(event.target.a.id);
  }
  function initializeHtmlPlayer(videoId,iframeId,videoUrl,x){
    //console.log('initializePlayer - htmlVideoRay[videoId]',videoId,htmlVideoRay[videoId])
    hp.stopOtherVids(iframeId);
    var video = document.createElement('video');
    video.src = videoUrl;
    video.autoplay = true;
    video.id = iframeId;
    video.className += "html-video-player";
    video.controls = true;
    hp.htmlVideoRay[iframeId] = video;
    $(x).replaceWith(hp.htmlVideoRay[iframeId]);
    video.addEventListener('play', function(event){
      hp.stopOtherVids(iframeId)
    });
    video.addEventListener('pause', function(event){
      hp.stopOtherVids()
    });
  }
  function showHideArrows(swiper){
    if(swiper.prevIndex === swiper.activeIndex){
      swiper.activeIndex += 1;
    }
    if(swiper.slides.length - 1 === swiper.activeIndex){
      swiper.allowSlideNext = false;
    }else if(!swiper.allowSlideNext){
      swiper.allowSlideNext = true;
    }
    if(swiper.activeIndex === 0){
      swiper.allowSlidePrev = false;
    }else if(!swiper.allowSlidePrev){
      swiper.allowSlidePrev = true;
    }
    swiper.prevIndex = swiper.activeIndex
  }


  hp.swipers.html_video_slide_swipe=html_video_slide_swipe;

}
